module.exports = __webpack_public_path__ + "img/service4.f6ac92b8.png";